import { render, staticRenderFns } from "./ReviewCardBody.vue?vue&type=template&id=00693ff4&"
import script from "./ReviewCardBody.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardBody.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00693ff4')) {
      api.createRecord('00693ff4', component.options)
    } else {
      api.reload('00693ff4', component.options)
    }
    module.hot.accept("./ReviewCardBody.vue?vue&type=template&id=00693ff4&", function () {
      api.rerender('00693ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardBody.vue"
export default component.exports